import { gsap } from "gsap";
import Swiper from './../imports/import-swiper';
import { bindCursorHoverEffect } from './cursor.js';

export default ()=>{
  const items = document.querySelectorAll('.w-info__item');

  items.length? itemsInit(): false;

  function itemsInit(){

    let sliderEl  = document.querySelector('.w-info .wrapper');

    if (sliderEl) {
      const slider = new Swiper(sliderEl, {
        wrapperClass: 'w-info__grid',
        slideClass: 'w-info__col',
        speed: 500,
        allowTouchMove: true,
        loop: true,
        loopAdditionalSlides: 1,
        slidesPerView: 3,
        initialSlide: 1,
        spaceBetween: 34,

        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          1080: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
        },
        on: {
          slideChange: () => {
            bindCursorHoverEffect()
          }
        }
      });
    }

    let itemsN = document.querySelectorAll('.w-info__item');
    itemsN.forEach(function(item) {
      let text = item.querySelector('.w-info__item-text');
      let textHeight = text.offsetHeight;
      text.style.height = 0;

      item.addEventListener('mouseenter', (e) => {
        gsap.to(text, {
          height: textHeight,
          duration: 0.5
        });
      });
      item.addEventListener('mouseleave', (e) => {
        gsap.to(text, {
          height: 0,
          duration: 0.5,
          ease: "power2.inOut"
        });
      });
    });
  }
}
